import { render, staticRenderFns } from "./EtsyTransferModule.vue?vue&type=template&id=37cba67c"
import script from "./EtsyTransferModule.vue?vue&type=script&lang=js"
export * from "./EtsyTransferModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports